import Coordinates from '@/types/Coordinates';
import Api from '@/services/api/ApiServiceFabrick';

export const getAddress = async(coord: Coordinates): Promise<string|null> => {
  if(coord.lat && coord.lng) {
    try {
      const address = await Api().getReverseGeoLocation(Number(coord.lat), Number(coord.lng));
      if (address) {
        return Promise.resolve(address);
      }
    } catch(err) {
      console.log(err);
    }
  }
  return Promise.resolve(null);
}
